//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from './title'
import { InsurStore } from '../store'

    export default {
        name:'InDetails',
        data() {
            return {
                title:"",
                list: [],
                contact:{},
                settlement_list:[]
            }
        },
        components: {
            InTitle,
        },
        computed: {
            insurance() {
                return InsurStore.insurance
            }
        },
        created() {
            this.settlement_list = this.insurance.settlement_list

        },
        methods: {
            // init() {
            //     this.bs = new BScroll(this.$refs.scroll, {
            //         startX: 0,
            //         click: true,
            //         scrollX: true,
            //         scrollY: false,
            //         eventPassthrough: "vertical"
            //     })
            // }
            telClick(number){
                this.openCall(number)
                this.STATISTICS_CONFIG.insur_proinfo_contact_click()
            }
        }
    }
